export default {
      id: "vague_footer-usage",
      viewBox: "0 0 2000 147",
      url: "../dist/images/" + "sprite.svg#vague_footer-usage",
      toString: function () {
        return this.url;
      }
    }